import { MIXED_TYPES, ModelKinds } from '../../../../consts';

export const SUPPORTED_MIXED_MODEL_COMPONENT = [
    MIXED_TYPES[ModelKinds.CONVERSION_EVENTS],
    MIXED_TYPES[ModelKinds.ENGAGEMENT],
    MIXED_TYPES[ModelKinds.FUNNEL],
];
